import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	reporter: {
		id: 'search-page.filters.names.reporter',
		defaultMessage: 'Reporter',
		description: 'Label for filtering by reporter',
	},
	jiraFilterContributorPlaceholder: {
		id: 'search-page.jira.filter.reporter.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for reporter filter search input',
	},
	jiraFilterReporterLabelSelected: {
		id: 'search-page.jira.filter.reporter.selected',
		defaultMessage: 'Selected',
		description: 'Jira reporter filter selected label',
	},
	jiraFilterReporterLabelUnselected: {
		id: 'search-page.jira.filter.reporter.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira reporter filter unselected label',
	},
});
